import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { ExaDbUpdateTagsPdbProps, newExaDbUpdateTagsPdb } from "./ExaDbUpdateTagsPdb";

export interface ExaDbEditTagsPdbProps extends OperationActionProps {
  databaseId: string;
  defaultTags?: { name: string; value: string; }[];
}

const ExaDbEditTagsPdb = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: ExaDbEditTagsPdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsPdb } = useOperation<ExaDbUpdateTagsPdbProps>(newExaDbUpdateTagsPdb);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTagsPdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newExaDbEditTagsPdb = (
  props: ExaDbEditTagsPdbProps,
): JSX.Element => (<ExaDbEditTagsPdb {...props} />);
